var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon",attrs:{"width":_vm.width,"height":_vm.height}},[_c('use',{attrs:{"xlink:href":`${_vm.test}#${_vm.name}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }